/**
 * Concatenates two knowledge-marker lists (knots/tags/connections), de-duplicating by name — marker
 * identity in this codebase is the name (see `AdvancedSearchService.addKnowledgeItem` and
 * `StitchFilters.format()`, which sends names). Ids only break the tie when a name is missing (ids
 * are optional, so comparing undefined===undefined would drop distinct un-id'd markers). Base
 * entries win.
 */
export function mergeMarkers<T extends { id?: string; name?: string }>(base?: T[], extra?: T[]): T[] {
  const merged = [...(base ?? [])];
  for (const item of extra ?? []) {
    const isDuplicate = merged.some((existing) =>
      existing.name != null && item.name != null
        ? existing.name === item.name
        : // Ids break the tie only when actually present: both fields are optional, and a bare
          // undefined === undefined comparison would collapse distinct anonymous markers.
          existing.id != null && existing.id === item.id,
    );
    if (!isDuplicate) {
      merged.push(item);
    }
  }
  return merged;
}
